
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ie/promotions/freenow-offer",
      function () {
        return require("private-next-pages/ie/promotions/freenow-offer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ie/promotions/freenow-offer"])
      });
    }
  